import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { Panel } from '../../../common/panel'
import { HIGH_LIGHT_TITLE, SCORE_OPTION } from '../constants'
import withLoadingFeedBack from '../hoc/withLoadingFeedback'
import { selectCurrentScore } from '../store/slice'
import TableComponent from './TableComponent'
import { selectLoading, selectSegmentProvince } from './store/slice'
import { exportProvince, getProvince } from './store/thunk'

const Province = () => {
  const dispatch = useDispatch()
  const settingParams = useSettingParams()

  const currentScore = useSelector(selectCurrentScore)
  const isLoading = useSelector(selectLoading)
  const data = useSelector(selectSegmentProvince())
  const locale = useSelector((state) => state.i18n.locale)

  const isCreditScore = currentScore === SCORE_OPTION.CREDIT_SCORE
  const Container = withLoadingFeedBack(isLoading, data)(TableComponent)

  useEffect(() => {
    if (!settingParams) return
    dispatch(getProvince(settingParams))
  }, [settingParams, locale])

  return (
    <Panel
      label={`portfolio.segment.PORTFOLIO_ALLOCATION_BY_PROVINCE${
        isCreditScore ? '' : '2'
      }`}
      isI18n={true}
      downloadCsv={{
        downloadFunc: () => exportProvince(settingParams),
      }}
      className={HIGH_LIGHT_TITLE.mainProvince}
    >
      <Container isCreditScore={isCreditScore} />
    </Panel>
  )
}

export default Province
